<template>
  <div>
    <div>
      <div class="manage-company-answers__header u-margin-bottom-medium">
        <div class="row u-margin-bottom-medium justify-content-between">
          <div class="col">
            <BackButton class="u-margin-bottom-small"> </BackButton>
            <div class="manage-company-answers__header-text" v-if="selectedQuestionType">
              <span>{{ selectedQuestionType.name }}</span> questionnaire for
              <span class="text-primary">{{ company.name }}</span>
            </div>
          </div>
          <div v-if="checkIfSeeAllQuestionnaire()" class="col">
            <ProgressBarSecondary
              class="manage-company-answers__progressBar"
              title="Questionnaire Progress"
              :button_reload="true"
              :loading="loadingProgress"
              :progress="progress"
              :total="total"
              unit_name="Questions"
              @reload="reloadData()"
            >
            </ProgressBarSecondary>
          </div>
          <div v-else class="col">
            <span class="total_amount_questions"> {{ total }} Questions </span>
          </div>
        </div>

        <div class="row justify-content-center">
          <div class="col-6">
            <SmallSearch @search="search = $event" />
          </div>
          <div class="col-1">
            <p-button icon outline @click.native.prevent="openFilters = true">
              <i class="fas fa-filter" />
            </p-button>
          </div>
        </div>

        <div class="row" v-if="selectedFilters.length > 0">
          <span class="filters-label">Filters:</span>
          <div v-for="(selectedFilter, index) in selectedFilters" v-bind:key="index">
            <span class="col"
              >{{ index + 1 }}.
              <span v-if="selectedFilter.name">
                {{ selectedFilter.name }}
              </span>
              <span v-else :class="filterClass(selectedFilter)">
                {{ selectedFilter }}
              </span>
            </span>
          </div>
        </div>
      </div>
      <div class="manage-company-answers__body">
        <QuestionsList
          :answers="answers"
          :questions="questions"
          :search="search"
          :company="company"
          :loading="loading"
          :filters="selectedFilters"
          :question-type="selectedQuestionType"
        />
      </div>
    </div>
    <ModalTemplate
      component-name="FiltersModal"
      :data="{
        header: 'Set Filters',
        checkedFilters: selectedFilters,
        filtersOptions: {
          Categories: categories,
          Subcategories: subcategories,
        },
      }"
      :clicked="openFilters"
      @update:field="openFilters = false"
      @submit="setFilters($event)"
    >
    </ModalTemplate>
  </div>
</template>

<script>
import BackButton from '../../components/buttons/BackButton';
import SmallSearch from '../../components/search/SmallSearch';
import QuestionsList from '../../components/Questions/QuestionsList';
import QuestionHasTypeController from '../../controllers/QuestionHasType/QuestionHasTypeController';
import MoonLoader from '../../components/svg/SvgLoaderMoon';
import CompanyAnswerController from '../../controllers/QuestionAnswer/CompanyAnswerController';
import ModalTemplate from '../../components/modals/ModalTemplate';
import CategoryController from '../../controllers/Category/CategoryController';
import SubcategoryController from '../../controllers/Category/SubcategoryController';
import ProgressBarSecondary from '@/components/Bars/ProgressBarSecondary';
import CalculateQuestionProgressController from '@/controllers/Question/CalculateQuestionProgressController';
import checkIfCanSeeQuestionnaire from '@/router/scopes/questionnaire/CheckIfCanSeeQuestionnaire';

export default {
  name: 'ManageCompanyAnswers',
  components: { ProgressBarSecondary, ModalTemplate, MoonLoader, QuestionsList, SmallSearch, BackButton },
  data() {
    return {
      selectedQuestionType: null,
      company: null,
      questions: null,
      answers: null,
      loading: false,
      search: '',
      questionsLoading: true,
      openFilters: false,
      categories: [],
      subcategories: [],
      selectedFilters: [],
      total: 100,
      progress: 0,
      loadingProgress: false,
    };
  },
  async mounted() {
    this.loading = true;
    this.loadingProgress = true;
    await this.setCompany(this.$route.query.company);
    await this.setSelectedQuestionType();
    await this.getQuestionsOfType();
    await this.getAnswers();
    await this.setCategories();
    await this.setSubcategories();
    if (this.$route.query.selectedFilters) this.setFilters(this.$route.query.selectedFilters);
    if (this.$route.query.searchBy) this.setSearch(this.$route.query.searchBy);
    this.loading = false;
    this.loadingProgress = false;
  },
  methods: {
    setCompany(company) {
      this.company = company;
    },
    setSelectedQuestionType() {
      this.selectedQuestionType = this.$route.query.selectedQuestionType;
    },
    async getQuestionsOfType() {
      this.questions = await QuestionHasTypeController.show(this.$route.query.selectedQuestionType.id, {
        company_id: this.$route.query.company.company_id,
      });
      this.calcTotal(this.questions);
    },
    async getAnswers() {
      this.answers = await CompanyAnswerController.show(this.$route.query.company.company_id, {
        question_type_id: this.$route.query.selectedQuestionType.id,
      });
      this.calcProgress(this.answers);
    },
    setFilters(filters) {
      // console.log(filters)
      this.selectedFilters = filters;
    },
    setSearch(searchBy) {
      this.search = searchBy;
    },
    async setCategories() {
      this.categories = await CategoryController.index();
    },
    async setSubcategories() {
      this.subcategories = await SubcategoryController.index();
    },
    calcTotal(questions) {
      this.total = CalculateQuestionProgressController.calcTotal(questions);
      // let values = Object.values(questions);
      // values.forEach(value => {
      //   let sub_values = Object.values(value)
      //   sub_values.forEach(sub_value => {
      //     this.total += Object.values(sub_value).length
      //   })
      // })
    },
    calcProgress(answers) {
      this.progress = CalculateQuestionProgressController.calcProgress(answers);
    },
    async reloadData() {
      this.loadingProgress = true;
      await this.getAnswers();
      this.loadingProgress = false;
    },
    checkIfSeeAllQuestionnaire() {
      return checkIfCanSeeQuestionnaire();
    },
    filterClass(filter) {
      let result = {
        'text-danger': true,
      };
      if (filter === 'Not Answered') {
        result = {
          'text-disabled': true,
        };
      }
      if (filter === 'In Progress') {
        result = {
          'text-warning': true,
        };
      }
      if (filter === 'Done') {
        result = {
          'text-primary': true,
        };
      }
      return result;
    },
  },
};
</script>

<style scoped>
.total_amount_questions {
  float: right;
  text-transform: uppercase;
  font-size: 2.3rem;
}

.filters-label {
}
</style>
